import React from 'react';
import PropTypes from 'prop-types';

import { WELLBEING_OPTIONS } from '../utils';

import WellbeingScaleCard from '../WellbeingScaleCard';

import './wellbeing-scale.scss';

const WellbeingScale = ({ title, selectedItem, selectItem }) => {
  const options = WELLBEING_OPTIONS;

  return (
    <section className="wellbeing-scale">
      <h3 className="wellbeing-scale_title">{title}</h3>
      <ul className="wellbeing-scale__cards">
        {options.map((option) => (
          <WellbeingScaleCard key={option.id} cardInfo={option} selectedItem={selectedItem} selectItem={selectItem} />
        ))}
      </ul>
    </section>
  );
};

WellbeingScale.propTypes = {
  title: PropTypes.string.isRequired,
  selectedItem: PropTypes.shape({}).isRequired,
  selectItem: PropTypes.func.isRequired,
};

export default WellbeingScale;
